
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dining/toplists/[id]",
      function () {
        return require("private-next-pages/dining/toplists/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dining/toplists/[id]"])
      });
    }
  